export default __webpack_public_path__ + "images/0xbc0d0650412ef353d672c0bbd12efff90591b251.png";